import script from "./ConstructionAssociation.vue?vue&type=script&setup=true&lang=js"
export * from "./ConstructionAssociation.vue?vue&type=script&setup=true&lang=js"

import "./ConstructionAssociation.vue?vue&type=style&index=0&id=2062704e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2062704e"]])

export default __exports__